<template>
  <div class="father">
    <div class="item_div">
      <div class="tv_div">
        <p class="title">贯彻“以客户为中心”的服务理念推行全面细致的服务</p>
        <p class="line"></p>
        <p class="content">推行全面而细致的服务</p>
        <p class="content">围绕“高规格、更专业、高品质”的服务宗旨开展工作，使各环节的服务工作落到了实处。</p>
      </div>
      <div class="img_div">

      <img class="img1" src="../../../static/img/物业icon6.png"/>
      <img class="img2" src="../../../static/img/物业icon61.png"/>
      </div>
    </div>
    <div class="item_div">
      <div class="tv_div">
        <p class="title">打造“客户视角”服务体系诠释人性服务标准</p>
        <p class="line"></p>
        <p class="content">以客户为导向，从发掘客户需求入手，提供主动、贴心、用心、到位的服务。</p>
      </div>
      <div class="img_div">

      <img class="img1" src="../../../static/img/物业icon7.png"/>
      <img class="img2" src="../../../static/img/物业icon71.png"/>
      </div>
    </div>
    <div class="item_div">
      <div class="tv_div">
        <p class="title">推行“安全至上”的管理理念创建平安美丽家园</p>
        <p class="line"></p>
        <p class="content">针对企事业单位合作客户群，不断延伸安全管理触角，扎实推进安全生产管理，打造平安美丽家园。</p>
      </div>
      <div class="img_div">

      <img class="img1" src="../../../static/img/物业icon8.png"/>
      <img class="img2" src="../../../static/img/物业icon81.png"/>
      </div>
    </div>
    <div class="item_div">
      <div class="tv_div">
        <p class="title">构筑“智能化”服务管理模式让服务更高效更便捷</p>
        <p class="line"></p>
        <p class="content">让服务更高效更便捷</p>
        <p class="content">引入智能管理系统，实现“物业管理+互联网”的深度融合，提高便民服务快捷性，助力企业管理高效运行。</p>
      </div>
      <div class="img_div">

      <img class="img1" src="../../../static/img/物业icon9.png"/>
      <img class="img2" src="../../../static/img/物业icon91.png"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  computed: {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="stylus" scoped>
.father{
  width:100%;
}
.item_div{
  margin:1rem auto;
  // width:125rem;
  height:18rem;
  background :white;
  padding:2rem 9rem 2rem 6rem;
  color:var(--textBlue);
  text-align :left;
  display :flex;
  justify-content: space-between;
  align-items: center;
  .line{
    background:var(--textBlue);
    height:1px;
    width:6.5rem;
  }
  .title{
    font-size:2.7rem;
    font-family:bold;
  }
  .content{
    font-size:1.6rem;
    font-family:light;
  }
  img{
    object-fit: contain;
  }
  .img_div{
    position:relative;
    width:6rem;
    height:6rem;
    .img1{
      display :inline-block;
      width:100%;
      height:100%;
    }
    .img2{
      width:100%;
      height:100%;
      position:absolute;
      left:0;
      top:0;
      display :none;
    }
  }
}
.item_div:hover{
  background :var(--textBlue);
  color:white;
  .line{
    background:white;
  }
  .img_div{
    .img1{
      display :none;
    }
    .img2{
      display :inline-block;
      position:absolute;
      left:0;
      top:0;
    }
  }
}

@media (max-width: 800px) {
  .item_div{
    padding:2rem 2rem 2rem 2rem;
    p{
      margin:0 0 1rem;
    }

    .title{
      font-size:1.8rem;
    }
    .content{
      font-size:1.4rem;

    }
  }
}
</style>